<p-dialog [(visible)]="displayDialog" [modal]="true" [style]="{width: '40vw'}" (onHide)="onClosePopup()">
  <ng-template pTemplate="header">
    <div class="title">
      <strong>{{title}}</strong>
    </div>
  </ng-template>

  <div class="formgrid grid">
    <div style="width: 90%;" class="m-auto">
      @if (isSuccess) {
        <div class="row">
          <div class="row" style="height: 200px;align-items: center;text-align: center;">
            <div style="display: flex; flex-direction: column; align-items: center;">
              <span class="circle-progress circle">100%</span>
              <div class="successfully-message">
                <span style="background-color: #03aa03;border-radius: 50%; width:30px; height:30px; color:white; margin-right:10px">✓</span>
                Your file successfully imported.
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col button-center">
              <button pButton class="p-button-primary button-confirm" type="button" (click)="onClosePopup()"
              translate>buttons.close</button>
            </div>
          </div>
        </div>
      }

      @if (!isSuccess) {
        <div class="row">
          <div class="row" style="height: 200px;align-items: center;text-align: center;">
            <div>
              <div class="error-message"><span style="background-color:red;border-radius: 50%; width:30px; height:30px; color:white; margin-right:10px; display: inline-block;">!</span>
              Could not complete the operation.
            </div>
            <div>
              Please download the log file for error details.
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col button-center">
            <img src="assets/img/log-file.png" style="width: 40px;"/>
            <button pButton class="p-button-primary button-confirm" type="button" (click)="onDownload()"
            translate>buttons.download_log</button>
            <button pButton class="p-button-secondary button-cancel ml-2" type="button" (click)="onClosePopup()"
            translate>buttons.close</button>
          </div>
        </div>
      </div>
    }
    <div class="row">
      <div class="col"><br /></div>
    </div>
  </div>
</div>
</p-dialog>
